import { h, Component } from 'preact';
import { connect } from "react-redux";
import reduce from "../reducers";
import MenuObject from '../canvas/menu-object';
import * as actions from '../actions';
import store from '../store';
import util from '../util';
import constants from '../constants';
import Interactable from "../canvas/interactable";
import { Switch } from 'antd';
import tinycolor from 'tinycolor2';
import History from '../canvas/history';
import { DownOutlined } from '@ant-design/icons';

const { dispatch } = store;

export default @connect(reduce, actions)
class MenuContentEditHighlight extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isHighlighted: false,
      highlightWidth: 1,
      highlightRadius: 0,
      highlightBorderStyle: 'solid',
      highlightFillOpacity: 100,
      isApplyPopover: false,
    };

    this.openColorPickerBorder = () => {
      const activeItemId = this.props.activeItem.id;
      const highlightId = this.props.$element.find(`[data-id="${activeItemId}"]`).attr('data-highlight-id');
      let type = [constants.pickerTypes.highlightBorder, highlightId]
      store.dispatch(actions.setIsLeftMenuVisible(true));
      util.openColorPicker(type, false);
      util.nextTick(() => {
        Interactable.adjustSelectionBoxes();
      });
    }

    this.openColorPickerFill = () => {
      const activeItemId = this.props.activeItem.id;
      const highlightId = this.props.$element.find(`[data-id="${activeItemId}"]`).attr('data-highlight-id');
      let type = [constants.pickerTypes.highlightFill, highlightId]
      store.dispatch(actions.setIsLeftMenuVisible(true));
      util.openColorPicker(type, false);
      util.nextTick(() => {
        Interactable.adjustSelectionBoxes();
      });
    }

    this.startApplyToMoMode = (ev) => {
      ev.stopPropagation();
      this.setState({isApplyPopover: false});
      const activeItemId = this.props.activeItem.id;
      const highlightId = this.props.$element.find(`[data-id="${activeItemId}"]`).attr('data-highlight-id');
      store.dispatch(actions.setLastSelectedHighlightId(highlightId));
      MenuObject.startApplyToMoMode(this.props.$element, MenuObject.applyModes.highlightStyle)
    }

    this.applyToAll = () => {
      this.setState({isApplyPopover: false});
      const activeItemId = this.props.activeItem.id;
      const highlightId = this.props.$element.find(`[data-id="${activeItemId}"]`).attr('data-highlight-id');
      store.dispatch(actions.setLastSelectedHighlightId(highlightId));
      window.ConfirmationModal.show({
        title: 'Are you sure?',
        body: `This will apply the current highlight styles to the entire menu.`,
        acceptLabel: '<span id="applyToAllConfirmBtn">Yes, apply to all</span>',
        declineLabel: 'Cancel',
        hideOnAccept: false,
        onAccept: () => {
          util.onApplyToAllConfirm();
          util.nextTick(() => {
            MenuObject.applyToAll(this.props.$element, MenuObject.applyModes.highlightStyle);
            window.ConfirmationModal.hide();
          })
        },
        onDecline: () => {
          window.ConfirmationModal.hide();
        }
      });
    };

    this.toggleApplyPopover = () => {
      this.setState({isApplyPopover: !this.state.isApplyPopover});
    }

    this.onBlurApplyTrigger = (ev) => {
      this.setState({isApplyPopover: false});
    }
  }

  componentWillMount() {
    if (!this.props.$element) return;
    if (!this.props.activeItem) return;
    this.setCurrentHighlightSettings();
  }

  setCurrentHighlightSettings() {
    const activeItemId = this.props.activeItem.id;
    const menuItem = this.props.$element.find(`[data-id="${activeItemId}"]`);
    const highlightId = menuItem.attr('data-highlight-id');
    this.setState({ isHighlighted: menuItem.hasClass('highlighted') });
    const styles = store.getState().menuObjectStyles;
    if (styles[`item.highlighted#${highlightId}`]) {
      let borderArray = styles[`item.highlighted#${highlightId}`]['border'].split(' ');
      let bg = tinycolor(styles[`item.highlighted#${highlightId}`]['background']);
      this.setState({
        highlightWidth: parseInt(borderArray[0]),
        highlightBorderStyle: borderArray[1],
        highlightRadius: styles[`item.highlighted#${highlightId}`]['border-radius'] ? parseInt(styles[`item.highlighted#${highlightId}`]['border-radius']) : 0,
        highlightFillOpacity: bg ? bg.getAlpha() * 100 : 100,
      });
    }
  }

  toggleItemHighlight(val) {
    if (!this.props.$element) return;
    const activeItemId = this.props.activeItem.id;
    const menuItem = this.props.$element.find(`[data-id="${activeItemId}"]`);
    let highlightId = '';
    if (menuItem.attr('data-highlight-id')) {
      highlightId = menuItem.attr('data-highlight-id');
    } else {
      highlightId = util.UUID.get();
      menuItem.attr('data-highlight-id', highlightId);
    }
    if (val) {
      const firstStyles = this.getFirstStyles();
      const _this = this;

      function redo() {
        menuItem.addClass('highlighted');
        _this.setState({ isHighlighted: true });
      }
      function undo() {
        menuItem.removeClass('highlighted');
        _this.setState({ isHighlighted: false });
      }

      redo();
      const styles = MenuObject.getStyles(this.props.$element);
      const theseHighlightStyles = styles[`item.highlighted#${highlightId}`];

      function scrollDown() {
        util.nextTick(() => {
          $('.menu-object-content .item-details.scroller').animate({
            scrollTop: $('.menu-object-content .item-details.scroller .highlight-item').offset().top
          }, 500);
        })
      }

      if (theseHighlightStyles) {
        scrollDown();
        return;
      }
      
      let patches = [];
      const thisKey = `item.highlighted#${highlightId}`;
      if (firstStyles && firstStyles['border']) {
        patches = [
          { type: `item`, key: 'position', value: `relative` },
          { type: thisKey, key: 'content', value: `''` },
          { type: thisKey, key: 'position', value: 'absolute' },
          { type: thisKey, key: 'width', value:  'calc(100% + 10px)'},
          { type: thisKey, key: 'height', value: '100%' },
          { type: thisKey, key: 'margin', value: firstStyles['margin'] },
          { type: thisKey, key: 'border', value: firstStyles['border'] },
          { type: thisKey, key: 'background', value: firstStyles['background'] },
          { type: thisKey, key: 'border-radius', value: firstStyles['border-radius'] ? firstStyles['border-radius'] : '0px' },
          { type: 'item.highlighted>*', key: 'position', value: 'relative' },
          { type: `item.highlighted.self#${highlightId}`, key: 'padding', value: `5px 0` },
        ];
      } else {
        patches = [
          { type: `item`, key: 'position', value: `relative` },
          { type: thisKey, key: 'content', value: `''` },
          { type: thisKey, key: 'position', value: 'absolute' },
          { type: thisKey, key: 'width', value: 'calc(100% + 10px)' },
          { type: thisKey, key: 'height', value: '100%' },
          { type: thisKey, key: 'margin', value: '-6px 0 0 -6px' },
          { type: thisKey, key: 'border', value: '1px solid black' },
          { type: thisKey, key: 'background', value: "" },
          { type: 'item.highlighted>*', key: 'position', value: 'relative' },
          { type: `item.highlighted.self#${highlightId}`, key: 'padding', value: `5px 0` },
        ];
      }
      patches.forEach(patch => {
        MenuObject.patchStyles(this.props.$element, patch, true, false);
      })

      if (firstStyles && firstStyles['border']) {
        this.setCurrentHighlightSettings();
      }
      
      History.push(undo, redo, 'Update toggle menu object highlight');
      scrollDown();
    } else {
      menuItem.removeClass('highlighted');
      this.setState({ isHighlighted: false });
    }
  }

  onHighlightWidthUpdate(ev) {
    const activeItemId = this.props.activeItem.id;
    const highlightId = this.props.$element.find(`[data-id="${activeItemId}"]`).attr('data-highlight-id');
    const styles = store.getState().menuObjectStyles;
    const borderArray = styles[`item.highlighted#${highlightId}`]['border'].split(' ');
    let patches = [
      { type: `item.highlighted#${highlightId}`, key: 'border', value: `${ev.target.value}px ${borderArray[1]} ${borderArray[2]}` },
      { type: `item.highlighted#${highlightId}`, key: 'margin', value: `-${5 + parseInt(ev.target.value)}px 0 0 -${5 + parseInt(ev.target.value)}px` },
    ];
    patches.forEach(patch => {
      MenuObject.patchStyles(this.props.$element, patch);
    })
    this.setState({ highlightWidth: ev.target.value });
  }

  onHighlightRadiusUpdate(ev) {
    const activeItemId = this.props.activeItem.id;
    const highlightId = this.props.$element.find(`[data-id="${activeItemId}"]`).attr('data-highlight-id');
    const val = ev.target.value;
    let patch = { type: `item.highlighted#${highlightId}`, key: 'border-radius', value: `${val}px` };
    MenuObject.patchStyles(this.props.$element, patch);
    this.setState({ highlightRadius: ev.target.value });
  }

  onHighlightBorderStyleUpdate(style) {
    const activeItemId = this.props.activeItem.id;
    const highlightId = this.props.$element.find(`[data-id="${activeItemId}"]`).attr('data-highlight-id');
    const styles = store.getState().menuObjectStyles;
    const borderArray = styles[`item.highlighted#${highlightId}`]['border'].split(' ');
    let patch = { type: `item.highlighted#${highlightId}`, key: 'border', value: `${borderArray[0]} ${style} ${borderArray[2]}` };
    MenuObject.patchStyles(this.props.$element, patch);
    this.setState({ highlightBorderStyle: style });
  }

  onHighlightFillOpacityUpdate(ev) {
    const activeItemId = this.props.activeItem.id;
    const highlightId = this.props.$element.find(`[data-id="${activeItemId}"]`).attr('data-highlight-id');
    const val = ev.target.value;
    const styles = store.getState().menuObjectStyles;
    let tc = styles[`item.highlighted#${highlightId}`]['background'] ? tinycolor(styles[`item.highlighted#${highlightId}`]['background']) : tinycolor('#fff');
    tc.setAlpha(val / 100);
    let patch = { type: `item.highlighted#${highlightId}`, key: 'background', value: tc.toRgbString() };
    MenuObject.patchStyles(this.props.$element, patch);
    this.setState({ highlightFillOpacity: val });
  }

  getFirstStyles() {
    let firstStyles = {};
    $('.pages [data-component="menu-object"]').each(function() {
      const $this = $(this);
      if ($this.find('.item.highlighted').length > 0) {
        const id = $this.find('.item.highlighted').first().attr('data-id');
        const styles = MenuObject.getStyles($this);
        firstStyles = styles[`item.highlighted#${id}`];
        return false;
      }
    })
    return firstStyles;
  }

  render(props, state) {
    const styles = store.getState().menuObjectStyles;
    let borderColor = '#000';
    let backgroundColor = '#fff';

    if (props.activeItem && props.$element) {
      const activeItemId = props.activeItem.id;
      const highlightId = props.$element.find(`[data-id="${activeItemId}"]`).attr('data-highlight-id');
      if (styles[`item.highlighted#${highlightId}`]) {
        if (styles[`item.highlighted#${highlightId}`]['border']) {
          borderColor = styles[`item.highlighted#${highlightId}`]['border'].split(' ')[2];
        }
  
        if (styles[`item.highlighted#${highlightId}`]['background']) {
          let tc = tinycolor(styles[`item.highlighted#${highlightId}`]['background']);
          tc.setAlpha(1);
          backgroundColor = tc.toRgbString();
        }
      }
    }

    return (
      <div className="highlight-item">
        <div className="switch">
          <div>
            <b>Highlight Item</b>
            <Switch
              size={'small'}
              onChange={(val) => this.toggleItemHighlight(val)}
              checked={this.state.isHighlighted}
              style={{marginLeft: '5px'}}
            />
          </div>
          <div className={`apply-to-all-dd ${!this.state.isHighlighted ? 'disabled' : ''}`}>
            <button className={'to-all'} onClick={() => this.toggleApplyPopover()} onBlur={(ev) => this.onBlurApplyTrigger(ev)}>
              Apply to... <DownOutlined/>
            </button>
            <div className={`to-all-dd-menu ${state.isApplyPopover ? 'show' : ''}`}>
              <ul>
                <li onMouseDown={() => this.applyToAll()}>All</li>
                <li onMouseDown={(ev) => this.startApplyToMoMode(ev)}>Selected</li>
              </ul>
            </div>
          </div>
        </div>
        {this.state.isHighlighted && <div className="highlight-settings">
          <ul className="slider-list">
            <li className="section-label">BORDER</li>
            <li className="color-item slider-item">
              <label>Color</label>
              <div onClick={() => this.openColorPickerBorder()} className="color-swatch" style={{backgroundColor: borderColor}}/>
            </li>
            <li className="slider-item">
              <div className={'slider-wrap'}>
                <label>Width</label>
                <div className="toolbar-wrap">
                  <input className="slider" type="range" min="0" max="10" step="1" value={this.state.highlightWidth} onChange={(ev) => this.onHighlightWidthUpdate(ev)} />
                </div>
                <input className="value" type="number" min="0" max="10" step="1" value={this.state.highlightWidth} disabled="disabled" />
              </div>
            </li>
            <li className="slider-item">
              <div className={'slider-wrap'}>
                <label>Radius</label>
                <div className="toolbar-wrap">
                  <input className="slider" type="range" min="0" max="10" step="1" value={this.state.highlightRadius} onChange={(ev) => this.onHighlightRadiusUpdate(ev)} />
                </div>
                <input className="value" type="number" min="0" max="10" step="1" value={this.state.highlightRadius} disabled="disabled" />
              </div>
            </li>
            <li className="borderstyle-item slider-item">
              <label>Style</label>
              <div className="borderstyles">
                <div className={`borderstyle solid hint--bottom ${state.highlightBorderStyle === 'solid' ? 'active' : ''}`} data-hint="Solid" onClick={() => this.onHighlightBorderStyleUpdate('solid')}>
                  <div/>
                </div>
                <div className={`borderstyle dotted hint--bottom ${state.highlightBorderStyle === 'dotted' ? 'active' : ''}`} data-hint="Dotted" onClick={() => this.onHighlightBorderStyleUpdate('dotted')}>
                  <div/>
                </div>
                <div className={`borderstyle dashed hint--bottom ${state.highlightBorderStyle === 'dashed' ? 'active' : ''}`} data-hint="Dashed" onClick={() => this.onHighlightBorderStyleUpdate('dashed')}>
                  <div/>
                </div>
              </div>
            </li>
            <li className="section-label">FILL</li>
            <li className="color-item slider-item">
              <label>Color</label>
              <div onClick={() => this.openColorPickerFill()} className="color-swatch" style={{backgroundColor: backgroundColor}}/>
            </li>
            <li className="slider-item">
              <div className={'slider-wrap'}>
                <label>Opacity</label>
                <div className="toolbar-wrap">
                  <input className="slider" type="range" min="0" max="100" step="1" value={this.state.highlightFillOpacity} onChange={(ev) => this.onHighlightFillOpacityUpdate(ev)} />
                </div>
                <input className="value" type="number" min="0" max="100" step="1" value={this.state.highlightFillOpacity} disabled="disabled" />
              </div>
            </li>
          </ul>
        </div>}
      </div>
    )
  }
}
